import { render, staticRenderFns } from "./fulfillment-new.vue?vue&type=template&id=04d273d5&scoped=true"
import script from "./fulfillment-new.vue?vue&type=script&lang=js"
export * from "./fulfillment-new.vue?vue&type=script&lang=js"
import style0 from "./fulfillment-new.vue?vue&type=style&index=0&id=04d273d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d273d5",
  null
  
)

export default component.exports